const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Your Window Into the Financial World</h1>
        <p>
          Stay informed, stay strategic, stay ahead.

          {/* Whether you’re hedging against inflation or capitalizing on short-term
          price shifts, The Pips provides an intuitive platform for both
          precision and performance. */}
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
